<template>
  <div class="password-reset-page container">
    <Toolbar title-trag="h1" class="mb-5">
      <template #title>
        Восстановление пароля
      </template>
    </Toolbar>
    <ContentBlock class="password-reset-page__card">
      <form @submit.prevent="submit" class="reset-form">
        <AppControl
          label="Пароль"
          class="reset-form__control"
          :error="getError('password')"
        >
          <AppInput
            v-model="$v.form.password.$model"
            class="reset-form__input"
            :invalid="isInvalid('password')"
            placeholder="Придумайте пароль"
            theme="third"
            type="password"
          />
        </AppControl>

        <AppControl
          label="Повторите пароль"
          class="reset-form__control"
          :error="getError('repeatPassword')"
        >
          <AppInput
            v-model="$v.form.repeatPassword.$model"
            class="reset-form__input"
            :invalid="isInvalid('repeatPassword')"
            placeholder="Повторите пароль"
            theme="third"
            type="password"
          />
        </AppControl>

        <p class="signin__message">{{ message }}</p>

        <AppBtn
          type="submit"
          class="reset-form__submit"
          color="third"
          :loading="loading"
        >
          Отправить
        </AppBtn>
      </form>
    </ContentBlock>
  </div>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar/";
import AppControl from "@/components/ui/control/AppControl.vue";
import { requestAlert, showAlert } from "@/core/common/";
import { getValidationMessage } from "@utils/validation-messages";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import service from "@/services/auth";

const defaultForm = () => ({
  password: "",
  repeatPassword: ""
});

export default {
  name: "PasswordResetPage",

  components: {
    AppControl,
    Toolbar
  },

  data: () => ({
    form: defaultForm(),
    formErrors: {},
    loading: false,
    message: ""
  }),

  breadcrumb: {
    title: "Восстановление пароля",
    to: "/password-reset"
  },

  validations: {
    form: {
      password: { required, minLength: minLength(6) },
      repeatPassword: { sameAs: sameAs("password") }
    }
  },

  computed: {
    token() {
      return this.$route.query.token;
    }
  },

  methods: {
    clearError(field) {
      delete this.formErrors[field];
    },

    getError(field) {
      return (
        getValidationMessage(this.$v.form[field]) ||
        (this.formErrors[field] && this.formErrors[field][0])
      );
    },

    isInvalid(field) {
      return this.$v.form[field].$error || !!this.formErrors[field];
    },

    async submit() {
      if (this.loading) return;
      this.formErrors = {};
      this.message = "";
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;

      try {
        const { success, data, message } = await service.resetPassword(
          this.token,
          this.form.password
        );
        if (success) {
          this.$router.replace({ name: "home" });
          showAlert(message);
        } else {
          this.formErrors = data || {};
          this.message = message || "Не удалось выполнить запрос.";
        }
      } catch {
        requestAlert();
      }

      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.password-reset-page {
  &__card {
    padding: 35px;
  }
  @include breakpoint("sm-and-down") {
    &__card {
      padding: 25px 25px;
    }
  }
}

.reset-form {
  width: 400px;
  max-width: 100%;
  margin: 0 auto;

  &__control {
    margin-bottom: 25px;
  }

  &__input {
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
    height: 60px;
  }

  &__submit {
    width: 270px;
    max-width: 100%;
    height: 55px;
    text-transform: uppercase;
    margin: 5px auto 0;
    display: flex;
    font-size: 24px;
  }
  &__message {
    text-align: center;
    margin-bottom: 20px;
    height: 18px;
    color: colors(text-2);
  }
}
</style>
